import createLitDispatcher from 'lit-dispatcher';

export const dispatcher = createLitDispatcher();
